<form [formGroup]="formGroup" #searchForm>
  <p-accordion styleClass="cfc-collapse-container">
    <p-accordionTab [(selected)]="!collapse">
      <div class="cfc-conditional-container mb-20">
        <ng-container *ngIf="conditionsTemplate">
          <ng-container *ngTemplateOutlet="conditionsTemplate"></ng-container>
        </ng-container>
        <ng-container *ngIf="advanced; else defaultAdvancedArea">
          <div class="mb-10">
            <button
              class="cfc-advanced-toggle-button"
              [ngClass]="{ active: advancedConditionalFormActiveState }"
              (click)="toggleAdvancedConditionalFormActiveState()"
            >
              {{ 'Library.UI.SearchForm.AdvancedSearch' | translate
              }}<i class="pi pi-triangle-under"></i>
            </button>
          </div>
          <p-accordion styleClass="cfc-collapse-container">
            <p-accordionTab [(selected)]="advancedConditionalFormActiveState">
              <ng-container *ngIf="advancedTemplate">
                <ng-container
                  *ngTemplateOutlet="advancedTemplate"
                ></ng-container>
              </ng-container>
            </p-accordionTab>
          </p-accordion>
        </ng-container>
        <ng-template #defaultAdvancedArea>
          <ng-container *ngIf="advancedTemplate">
            <ng-container *ngTemplateOutlet="advancedTemplate"></ng-container>
          </ng-container>
        </ng-template>
        <div class="p-text-center">
          <ng-container *ngIf="buttonsTemplate">
            <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
          </ng-container>
          <button
            *ngIf="showSearch"
            pButton
            type="button"
            label="{{ displaySearchText | translate }}"
            class="p-content-button mr-10"
            (click)="searchBtnClick($event)"
          >
            <i *ngIf="isDealerWeb" class="pi pi-find-white"></i>
          </button>
          <button
            *ngIf="showClear"
            pButton
            type="button"
            label="{{ displayClearText | translate }}"
            class="p-button-secondary p-content-button"
            (click)="cancelBtnClick($event)"
          >
            <i *ngIf="isDealerWeb" class="pi pi-cancel"></i>
          </button>
          <ng-container *ngIf="suffixButtonsTemplate">
            <ng-container
              *ngTemplateOutlet="suffixButtonsTemplate"
            ></ng-container>
          </ng-container>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</form>
<div class="cfc-collapse-toggle-container mb-20" *ngIf="showCollapseWidget">
  <hr class="cfc-divider" />
  <button
    pButton
    label="{{ (collapse ? 'Expand' : 'Collapse') | translate }}"
    type="button"
    [icon]="collapse ? 'pi pi-arrow-down-gold' : 'pi pi-arrow-up-gold'"
    iconPos="right"
    class="p-button-outlined cfc-collapse-button mh-10"
    (click)="toggleConditionalFormActiveState()"
  ></button>
  <hr class="cfc-divider" />
</div>
